export const REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME = 'text'

export const REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_QA_NAME =
  'requestEditDescriptionField'

export const REQUEST_EDIT_DESCRIPTION_MODAL_QA_NAME = 'requestEditDescription'
